import { useState } from 'react'
import { ToastMessage } from '@chegg-wt/core/components/Toast/types'
import { useDispatch } from 'react-redux'
import { showErrorToastForOneClick } from '@chegg-wt/core/state/citation/actions'

export interface ToastState {
  message: ToastMessage
}

interface UseToastProps {
  toastState: ToastState
  showToast: (message: ToastMessage) => void
  hideToast: () => void
}

/**
 *
 * Returns { message, a func to set the message string, and a func to hide toast
 */
export const useToast = (): UseToastProps => {
  const dispatch = useDispatch()
  const [message, setMessage] = useState<ToastMessage>(null)

  const handleShow = (msg: ToastMessage) => {
    setMessage(msg)
  }

  const handleHide = () => {
    setMessage(null)
    dispatch(showErrorToastForOneClick(false))
  }

  return {
    toastState: { message },
    showToast: handleShow,
    hideToast: handleHide,
  }
}
